export const getDataFromSessionStorage = (key: string) => {
  const rawData = window.sessionStorage.getItem(key);
  return rawData ? JSON.parse(rawData) : undefined;
};
